import { useSignal } from '@preact/signals'
import { useCallback } from 'preact/hooks'
import { useLocation } from 'wouter-preact'

import { Button, ComingSoonModal, HorizontalDivider } from 'components'

import { HubsSection } from './HubsSection'
import { PullRequestsSection } from './PullRequestsSection'
import { NewSmartContractButton } from './NewSmartContractButton'

const RightSidebar = () => {
	const [, setLocation] = useLocation()

	const cominingSoonModalContent = useSignal({
		isOpen: false,
		title: '',
		description: ''
	})

	const closeComingSoonModal = () => {
		cominingSoonModalContent.value = {
			isOpen: false,
			title: cominingSoonModalContent.value.title,
			description: cominingSoonModalContent.value.description
		}
	}

	const openComingSoonModal = (title: string, description: string) => {
		cominingSoonModalContent.value = {
			isOpen: true,
			title,
			description
		}
	}

	const navigateToSettings = useCallback(
		() => setLocation('/settings'),
		[setLocation]
	)

	return (
		<>
			<ComingSoonModal
				description={cominingSoonModalContent.value.description}
				isModalOpen={cominingSoonModalContent.value.isOpen}
				onCloseModal={closeComingSoonModal}
				title={cominingSoonModalContent.value.title}
			/>
			<aside class='h-full'>
				<NewSmartContractButton />
				<Button
					className='mt-2'
					onClick={navigateToSettings}
					size='normal'
					text='Settings'
					variant='secondary'
					fullWidth
				/>

				<div class='hidden space-y-5 lg:block'>
					<HorizontalDivider className='my-5' />
					<HubsSection openModal={openComingSoonModal} />
					<PullRequestsSection openModal={openComingSoonModal} />
				</div>
			</aside>
		</>
	)
}

export { RightSidebar }
